import React from "react";
import { MenuItem, Select, makeStyles } from "@material-ui/core/";
import KeyboardArrowDownRoundedIcon from "@mui/icons-material/KeyboardArrowDownRounded";
import { Divider } from "@mui/material";
import { UserCreatedSegmentIcon } from "./SVGs/userCreatedSegmentIcon";
import { DefaultSegmentIcon } from "./SVGs/defaultSegmentIcon";
import { AllAccountsFilterIcon } from "./SVGs/allAccountsFilterIcon";
import { NetNewFilterIcon } from "./SVGs/netNewFilterIcon";

const useStyles = makeStyles((theme) => ({
  select: {
    "& .MuiSelect-select:focus": {
      background: 'transparent',
    },
    "& .MuiSvgIcon-root": {
      marginTop: "7px",
      marginRight: "5px",
      minWidth: "auto",
      minHeight: "auto",
      height: "12px",
      width: "12px"
    },
  },
  menutext: {
    width: "100%",
    fontFamily: "Inter, sans-serif !important",
    fontSize: "12px",
    fontWeight: "500",
    color: "#424242",
  },
  selected: {
    background: "#DFE2DE !important",
  },
}))

const SegmentSelect = (props) => {
  const classes = useStyles();
  console.log("props in SegmentSelect", props);
  const permanentSegments = [
    {
      label: "All Accounts",
      icon: () => <AllAccountsFilterIcon />,
    },
    {
      label: "Target - CRM",
      icon: () => <img src={`${window._env_.B2_INTENT_SETTING}/logos/${props.crmSource ? props.crmSource?.toString().toLowerCase() : ""}.png`} alt="" style={{ width: "18px" }} />,
    },
    {
      label: "Target - Net New",
      icon: () => <NetNewFilterIcon />,
    },
  ]

  const filteredPermanentSegments = (props.isNetNewEnabled || props.new_new_permission)
  ? permanentSegments
  : permanentSegments.filter(seg => seg.label === "All Accounts");

  const segmentIconMap = filteredPermanentSegments.reduce((acc, item) => {
    acc[item.label] = item.icon;
    return acc;
  }, {});

  const matchedItems = props.loglist.filter(
    (item) =>
      filteredPermanentSegments.some((seg) => seg.label === item.listTitle) &&
      item.type === props.dataType
  );

  const remainingItems = props.loglist.filter(
    (item) =>
      !permanentSegments.some((seg) => seg.label === item.listTitle) &&
      item.type === props.dataType
  );

  return (
    <Select
      id={props.id}
      variant="outlined"
      style={{
        borderRadius: "6px",
        height: "32px",
        minWidth: "112px",
        width: "180px",
        backgroundColor: "#FFFFFF",
      }}
      value={props.value}
      IconComponent={KeyboardArrowDownRoundedIcon}
      onChange={props.onChange}
      MenuProps={{
        PaperProps: {
          style: {
            borderRadius: "6px",
            width: '135px',
            backgroundColor: '#FFFFFF',
          },
        },
        getContentAnchorEl: () => null,
        anchorOrigin: {
          vertical: 'bottom',
          horizontal: 'center'
        },
        transformOrigin: {
          vertical: 'top',
          horizontal: 'center',
        },
      }}
      inputProps={{
        style: {
          fontSize: "12px",
          color: "#3D3D3B",
          fontWeight: 500,
        },
      }}
      renderValue={(selectedValue) => {
      const matched = matchedItems.find(item => item.listTitle === selectedValue)
                  || remainingItems.find(item => item.listTitle === selectedValue);

      if (!matched) return <span>{selectedValue}</span>;

      const Icon = segmentIconMap[matched.listTitle] || (() => <UserCreatedSegmentIcon />);

      return (
          <div title={matched.listTitle} style={{ display: 'flex', alignItems: 'center', gap: '8px', overflow: "hidden" }}>
            <div style={{ width: "18px", height: '18px', flexShrink: 0 }}><Icon /></div>
            <span style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", display: "block" }}>{matched.listTitle}</span>
          </div>
      );
      }}
    >
      {/* {props?.loglist
        ?.reverse()
        .filter((data) => data.type === props.dataType)
        .map((data) => (
          <MenuItem key={data.listTitle} value={data.listTitle}>
            {data.listTitle}
          </MenuItem>
        ))} */}
        {matchedItems.map((data) => {
        const IconComponent = segmentIconMap[data.listTitle] || <DefaultSegmentIcon/>;
        return (
          <MenuItem
            key={data.listTitle}
            value={data.listTitle}
            classes={{ selected: classes.selected }}
            className={classes.menutext}
            style={{ fontSize: '12px', fontWeight: '500', color: '#424242' }}
          >
            <div title={data.listTitle} style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
              <div style={{ width: "18px", height: "18px", flexShrink: 0 }}>
                <IconComponent />
              </div>
              <span
                style={{
                  paddingLeft: '12px',
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  display: 'block',
                  maxWidth: 'calc(100% - 30px)',
                }}
              >
                {data.listTitle}
              </span>
            </div>
          </MenuItem>
        );
      })}

      {matchedItems.length > 0 && remainingItems.length > 0 && (
        <Divider sx={{ margin: '5px' }} />
      )}

      {remainingItems.map((data) => (
        <MenuItem
          key={data.listTitle}
          value={data.listTitle}
          classes={{ selected: classes.selected }}
          className={classes.menutext}
          style={{ fontSize: '12px', fontWeight: '500', color: '#424242' }}
        >
          <div title={data.listTitle} style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
          <div style={{ width: "18px", height: "18px", flexShrink: 0 }}>
            <UserCreatedSegmentIcon />
          </div>
          <span
                style={{
                  paddingLeft: '12px',
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  display: 'block',
                  maxWidth: 'calc(100% - 30px)',
                }}
              >{data.listTitle}</span>
          </div>
        </MenuItem>
      ))}
    </Select>
  );
};

export default SegmentSelect;
